const APP_STORE_ID = "6760034740";
// pt = provider token from App Store Connect → App Analytics. Leave "" until you
// have it; links still work and ct still records the campaign. Set it to enable
// full attribution.
const APP_STORE_PROVIDER_TOKEN = "";

/** Build a region-agnostic App Store link with an App Analytics campaign token. */
export function appStoreUrl(campaign: string): string {
  const params = new URLSearchParams({ mt: "8", ct: campaign });
  if (APP_STORE_PROVIDER_TOKEN) params.set("pt", APP_STORE_PROVIDER_TOKEN);
  return `https://apps.apple.com/app/id${APP_STORE_ID}?${params.toString()}`;
}

export const STORE_LINKS = {
  appStore: { label: "Download on the App Store" }, // href built per-location via appStoreUrl()
  googlePlay: { href: "#", label: "Get it on Google Play" }, // unchanged — no Play listing yet
} as const;

export const SHOW_ANDROID = process.env.NEXT_PUBLIC_SHOW_ANDROID === 'true';

export const CONTACT_EMAIL = "hello@keeps.cam";

/** Production site origin — used for canonical URLs, sitemap, robots and JSON-LD. */
export const SITE_URL = (
  process.env.NEXT_PUBLIC_SITE_URL ?? "https://keeps.cam"
).replace(/\/+$/, "");

export type NavLeaf = { label: string; href: string };
export type NavItem = NavLeaf;

/** Wedding SEO landing pages — footer links keep them crawlable from every page. */
export const WEDDING_LANDING_LINKS: readonly NavLeaf[] = [
  { label: "QR Code Photo Sharing", href: "/wedding-qr-code-photo-sharing" },
  { label: "Collect Guest Photos", href: "/collect-wedding-photos-from-guests" },
  { label: "Photo Booth Alternative", href: "/photo-booth-alternative-wedding" },
  { label: "Disposable Camera App", href: "/disposable-camera-wedding-app" },
] as const;

export const NAV_LINKS: readonly NavItem[] = [
  { label: "Features", href: "/#how-it-works" },
  { label: "Pricing", href: "/pricing" },
  { label: "Blog", href: "/blog" },
] as const;
